import { PackagingSelectionVariant } from "~/domains/product/components/PackagingSelection/PackagingSelectionVariant";
import { usePackagingSelectionLogic } from "~/domains/product/components/PackagingSelection/usePackagingSelectionLogic";
import { NewPackagingSelectionItem } from "~/domains/product/components/PackagingSelection/NewPackagingSelection/NewPackagingSelectionItem";
import { INVALID_PACKAGE_CODE } from "~/utils/constants";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import { NewPackagingSelectionItem as NewPackagingSelectionRadioItem } from "~/domains/product/components/PackagingSelection/NewPackagingSelection/v2/NewPackagingSelectionItem";
import { styled, Stack } from "~/common/mui";

export interface Props {
  className?: string;
  selectedCode: string;
  onSelectCode?: (packCode: string) => void;
  product: ProductDescriptor;
  variant?: PackagingSelectionVariant;
  initiallyExpanded?: boolean;
  disabled?: boolean;
  selectionType?: string;
}

const Root = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const NewPackagingSelection = ({
  product,
  variant = PackagingSelectionVariant.PDP,
  className,
  onSelectCode,
  selectedCode,
  initiallyExpanded,
  disabled,
  selectionType = "collapsible",
}: Props) => {
  const packages = usePackagingSelectionLogic({ product, variant });

  if (!packages?.length) {
    return null;
  }

  if (initiallyExpanded && packages.length && (!selectedCode || selectedCode === INVALID_PACKAGE_CODE)) {
    // Maybe this hack will give preselection logic time to kick in
    return null;
  }

  const isRadioTypePackageSelection = selectionType === "radio";

  return (
    <Root className={className} sx={isRadioTypePackageSelection ? { gap: 1 } : undefined}>
      {packages.map((pack) => {
        const commonProps = {
          key: pack.packCode,
          onSelect: onSelectCode ? () => onSelectCode(pack.packCode) : undefined,
          selected: selectedCode === pack.packCode,
          pack,
          productDescriptor: product,
          variant,
          disabled,
        };

        return isRadioTypePackageSelection ? (
          <NewPackagingSelectionRadioItem {...commonProps} />
        ) : (
          <NewPackagingSelectionItem
            {...commonProps}
            initiallyExpanded={initiallyExpanded && selectedCode === pack.packCode}
          />
        );
      })}
    </Root>
  );
};
